import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=ad122828"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=ad122828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports